import React from 'react';
import {
  DateField,
  Labeled,
  TextField,
} from 'react-admin';
import moment from 'moment';
import { citizenshipLabels } from '../../../helpers/mappings';
import { formatString } from '../../../helpers/utils';

import '../styles.css';

export default ({ record }) => (
  <table style={{ width: '100%' }}>
    <tbody>
      <tr>
        <td style={{ width: '50%' }}>
          <Labeled label="Citizenship">
            <span className="normalField">{citizenshipLabels[record.identity.citizenship]}</span>
          </Labeled>
        </td>
        <td style={{ width: '50%' }}>
          <Labeled label="Country of Residence">
            <span className="normalField">{record.identity.residenceCountry}</span>
          </Labeled>
        </td>
      </tr>
      <tr>
        <td>
          <Labeled label="Social Security Number">
            <span className="normalField">{formatString(record.identity.taxIdNum, '###-##-####')}</span>
          </Labeled>
        </td>
        <td>
          <Labeled label="Date of Birth">
            <span><DateField source="identity.dateOfBirth" record={record} style={{ display: 'inline-block' }} /><span className="normalField">&nbsp;({moment(record.identity.dateOfBirth).fromNow(true)} old)</span></span>
          </Labeled>
        </td>
      </tr>
      <tr>
        <td>
          <Labeled label="Street Address (Line 1)">
            <TextField source="identity.primaryAddress.line1" record={record} />
          </Labeled>
        </td>
        <td>
          <Labeled label="Street Address (Line 2)">
            <TextField source="identity.primaryAddress.line2" record={record} />
          </Labeled>
        </td>
      </tr>
      <tr>
        <td>
          <Labeled label="City">
            <TextField source="identity.primaryAddress.city" record={record} />
          </Labeled>
        </td>
        <td>
          <Labeled label="State">
            <TextField source="identity.primaryAddress.state" record={record} />
          </Labeled>
        </td>
      </tr>
      <tr>
        <td>
          <Labeled label="Country">
            <TextField source="identity.primaryAddress.country" record={record} />
          </Labeled>
        </td>
        <td>
          <Labeled label="Zip Code">
            <TextField source="identity.primaryAddress.zipcode" record={record} />
          </Labeled>
        </td>
      </tr>
    </tbody>
  </table>
);



// WEBPACK FOOTER //
// ./src/components/User/children/Identity_Show.jsx